export const projectPriority = [
  {
    name: `Niski`,
    value: "LOW",
    background: "#c2c2d6",
    font: "#fff",
  },
  {
    name: `Normalny`,
    value: "NORMAL",
    background: "#AAC1AE",
    font: "#fff",
  },
  {
    name: `Wysoki`,
    value: "HIGH",
    background: "#ff6600",
    font: "#fff",
  },
  {
    name: `Najwyższy`,
    value: "HIGHEST",
    background: "#e60000",
    font: "#fff",
  },
];

export const TaskStatuses = [
  {
    label: `Nowy`,
    value: "NEW",
    bgColor: "var(--BMX-blue)",
  },
  {
    label: `W trakcie`,
    value: "IN_PROGRESS",
    bgColor: "var(--BMX-warning)",
  },
  {
    label: `Ukończony`,
    value: "COMPLETED",
    bgColor: "var(--BMX-primary)",
  },
  {
    label: `Anulowany`,
    value: "CANCELLED",
    bgColor: "var(--BMX-error)",
  },
  {
    label: `Wstrzymany`,
    value: "ON_HOLD",
    bgColor: "var(--BMX-dark-grey)",
  },
];
